import * as React from 'react';
import { useNavigate } from 'react-router';
import type { PiletApi } from '@chess/platform-web';
import { registerCard } from '@chess/api-dashboard';
import { libraryLink, type FilterLink } from '@chess/api-insights/charts';
import { registerAggregator, useAggregate } from '@chess/api-model/react';
import '@chess/api-insights/charts.css';
import { OpeningResultsCard, TITLE } from './OpeningResultsCard.tsx';
import { OpeningResultsAggregator } from './OpeningResultsAggregator.ts';

// Openings card "Opening results" (2026-10-08): registers its own aggregator
// with the game store, reads its result and registers `OpeningResultsCard`
// as a card body (the section draws its frame)
// first in the Openings section (`home.section.openings`, order 5), which the
// Overview's Openings section and the Openings screen show. A slice opens the
// library filtered to its games (`libraryLink`, `stage-change`).
export function setup(app: PiletApi) {
  const getApi = <T,>(name: string) => app.getApi<T>(name);
  const aggregator = new OpeningResultsAggregator();
  registerAggregator(getApi, aggregator);
  const Card: React.FC = () => {
    const { result, state } = useAggregate(getApi, aggregator);
    const navigate = useNavigate();
    const link = React.useMemo<FilterLink>(() => libraryLink((path) => navigate(path)), [navigate]);
    if (state?.status !== 'ready') return state?.status === 'failed' ? null : <OpeningResultsCard loading />;
    return result ? <OpeningResultsCard result={result} link={link} /> : null;
  };
  registerCard(app, 'home.section.openings', Card, { order: 5, title: TITLE });
}
